import { asset } from '../lib/utils';
import { CheckIcon } from './Icons';

const groups = [
  {
    img: '/images/students.jpg',
    alt: 'ল্যাপটপ নিয়ে একসাথে পড়াশোনা করছে শিক্ষার্থীরা',
    tag: 'শিক্ষার্থী',
    title: 'যারা চাকরির জন্য নিজেকে প্রস্তুত করছেন',
    points: ['প্রজেক্ট, সার্ভে ও রেজাল্টের হিসাব নিজেই Excel-এ করুন', 'চাকরির আবেদনে দক্ষতা হিসেবে MS Excel যোগ করুন', 'সার্টিফিকেট দিয়ে সিভি আরও শক্তিশালী করুন'],
  },
  {
    img: '/images/office-a.jpg',
    alt: 'অফিসে সফলভাবে কাজ শেষ করে সহকর্মীদের হাই-ফাইভ',
    tag: 'অফিস কর্মী',
    title: 'যারা কাজ দ্রুত ও নির্ভুল করতে চান',
    points: ['রিপোর্ট ও হিসাবের কাজ অর্ধেক সময়ে শেষ করুন', 'বসের কাছে নির্ভুল ও গোছানো রিপোর্ট জমা দিন', 'প্রমোশন ও নতুন দায়িত্বের জন্য তৈরি থাকুন'],
  },
];

export default function Audience() {
  return (
    <section className="bg-slate-50 py-20">
      <div className="container-x">
        <div className="mx-auto max-w-2xl text-center">
          <span className="eyebrow">কাদের জন্য এই কোর্স</span>
          <h2 className="section-title">শিক্ষার্থী হোন বা চাকরিজীবী — এই কোর্স আপনার জন্য</h2>
          <p className="mt-4 text-lg text-slate-600">আগে থেকে কিছু জানা লাগবে না। একদম শুরু থেকে শেখানো হবে।</p>
        </div>

        <div className="mt-12 grid gap-8 md:grid-cols-2">
          {groups.map((g) => (
            <article key={g.tag} className="group overflow-hidden rounded-2xl bg-white shadow-sm ring-1 ring-slate-900/5 transition hover:shadow-xl">
              <div className="relative h-56 overflow-hidden">
                <img src={asset(g.img)} alt={g.alt} loading="lazy" className="h-full w-full object-cover transition duration-500 group-hover:scale-105" />
                <span className="absolute left-4 top-4 rounded-full bg-white/95 px-3 py-1 text-sm font-bold text-word-600 shadow">{g.tag}</span>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-slate-900">{g.title}</h3>
                <ul className="mt-4 space-y-2.5">
                  {g.points.map((p) => (
                    <li key={p} className="flex gap-2.5 text-slate-700">
                      <CheckIcon className="mt-1 h-4 w-4 shrink-0 text-excel-500" />
                      {p}
                    </li>
                  ))}
                </ul>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
